module.exports = __webpack_public_path__ + "static/media/imgop_Vectors.14f37674.jp2";